/* eslint-disable no-undef, indent */
import { Widget } from "blue-widgets";

class AlertBanner extends Widget {
  constructor(el) {
    super(el);
    this.showFrom = this.el.getAttribute("data-show-from");
    this.showTo = this.el.getAttribute("data-show-to");
    this.cookieName = this.el.getAttribute("data-cookie-name");
    this.cookieKey =
      this.el.getAttribute("data-cookie-key") ||
      this.el.getAttribute("data-cookie-group-name");
    this.cookieValue = "hidden";
    this.cookieExpiryDays = 365;

    this.init();
  }

  init() {
    this.currentCookieName = this.buildCookieName();
    this.collectOldBannerCookies();

    if (this.hasDismissedCookie()) {
      this.hideBanner();
      return;
    }

    if (!this.isWithinDisplayDateWindow()) {
      this.hideBanner();
      return;
    }

    this.showBanner();
    this.dismissBtn = this.el.querySelector("[data-dismiss-btn]");
    this.dismissBtn?.addEventListener?.("click", this.dismiss);
  }

  dismiss = () => {
    this.persistHiddenState();
    this.hideBanner();
  };

  buildCookieName = () => {
    const baseName = (this.cookieName || "alert-banner").trim();
    const key = (this.cookieKey || "default").trim();
    return `${baseName}-${key}`;
  };

  hasDismissedCookie = () => {
    const cookieValue = this.getCookie(this.currentCookieName);
    return cookieValue === this.cookieValue;
  };

  isWithinDisplayDateWindow = () => {
    const now = new Date();
    const fromDate = this.parseDate(this.showFrom);
    const toDate = this.parseDate(this.showTo);

    if (fromDate && now < fromDate) {
      return false;
    }

    if (toDate && now > toDate) {
      return false;
    }

    return true;
  };

  parseDate = (dateString) => {
    if (!dateString) {
      return null;
    }

    const parsedDate = new Date(dateString);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  persistHiddenState = () => {
    if (this.hasDismissedCookie()) {
      return;
    }

    this.setCookie(this.currentCookieName, this.cookieValue, this.cookieExpiryDays);
  };

  hideBanner = () => {
    this.el.setAttribute("aria-hidden", "true");
    this.el.classList.add("hide");
  };

  showBanner = () => {
    this.el.setAttribute("aria-hidden", "false");
    this.el.classList.remove("hide");
  };

  setCookie = (name, value, days) => {
    const expiresAt = new Date();
    expiresAt.setTime(expiresAt.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expiresAt.toUTCString()}; path=/; SameSite=Lax`;
  };

  getCookie = (name) => {
    const encodedName = `${name}=`;
    const cookieList = document.cookie.split(";");

    for (const cookieEntry of cookieList) {
      const cookie = cookieEntry.trim();
      if (cookie.startsWith(encodedName)) {
        return decodeURIComponent(cookie.substring(encodedName.length));
      }
    }

    return null;
  };

  deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  };

  collectOldBannerCookies = () => {
    const baseName = (this.cookieName || "alert-banner").trim();
    const cookieList = document.cookie.split(";");

    cookieList.forEach((cookieEntry) => {
      const cookie = cookieEntry.trim();
      if (!cookie) {
        return;
      }

      const [cookieKey] = cookie.split("=");
      const isAlertBannerCookie =
        cookieKey === baseName || cookieKey.startsWith(`${baseName}-`);
      const isCurrentCookie = cookieKey === this.currentCookieName;

      if (isAlertBannerCookie && !isCurrentCookie) {
        this.deleteCookie(cookieKey);
      }
    });
  };

  beforeRemove() {
    this.dismissBtn?.removeEventListener?.("click", this.dismiss);
  }
}

export default AlertBanner;
